import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { WorkUser } from '@work-frontend-monorepo/work-rest-api';

/**
 * Hinweis für User, die heute nicht angestellt sind (Eintritt in der Zukunft, ausgetreten, deaktiviert).
 * Gleiche Kriterien wie `UsersV2Service.IS_ACTIVE_USER()` im Backend; für Angestellte ein leerer String.
 */
@Pipe({
  name: 'userEmploymentHintPipe',
})
export class UserEmploymentHintPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);
  private readonly locale = inject(LOCALE_ID);

  transform(user: Pick<WorkUser, 'active' | 'entrydate' | 'exitdate' | 'loginPossibleUntil'> | null | undefined): string {
    if (!user) {
      return '';
    }
    const now = new Date();
    if (user.entrydate && new Date(user.entrydate) > now) {
      return this.translateService.instant('MEGASEARCH_USER_EINTRITT_AM', { date: formatDate(user.entrydate, 'dd.MM.yyyy', this.locale) });
    }
    const isEmployed =
      !!user.active &&
      !!user.entrydate &&
      (!user.exitdate || new Date(user.exitdate) > now) &&
      !!user.loginPossibleUntil &&
      new Date(user.loginPossibleUntil) > now;
    return isEmployed ? '' : this.translateService.instant('MEGASEARCH_USER_NICHT_MEHR_ANGESTELLT');
  }
}
